module.exports = "<img [src]=\"src\" [alt]=\"alt\" [className]=\"class\" >"